import React from "react";
import { FaCalendarAlt, FaPlus } from "react-icons/fa";

function EventsPageHeader({ onCreate }) {
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-2 text-xs font-bold uppercase tracking-[0.2em] text-orange-200 shadow-sm backdrop-blur-xl">
          <FaCalendarAlt />
          Compétitions & événements
        </div>

        <h1 className="mt-4 font-titre text-4xl font-bold leading-tight text-white sm:text-5xl">
          Toutes vos compétitions
        </h1>

        <p className="mt-3 max-w-2xl text-base font-medium leading-8 text-white/60 sm:text-lg">
          Suivez les compétitions attribuées au judoka, gérez les inscriptions,
          consultez les résultats et préparez les prochaines échéances.
        </p>
      </div>

      <button
        type="button"
        onClick={onCreate}
        className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-orange-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-orange-500/20 transition hover:-translate-y-0.5 active:translate-y-0"
      >
        <FaPlus />
        Nouvel événement
      </button>
    </div>
  );
}

export default EventsPageHeader;